/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { PfTvChart } from '@/screens/custom-elements';
import type { ViewModel } from './view-model';

export function ReplayView({ m }: { m: ViewModel }) {
  return (
    <div
      style={{
        padding: '12px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        boxSizing: 'border-box',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      {' '}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
        {' '}
        <div
          style={{
            display: 'flex',
            gap: '2px',
            padding: '3px',
            borderRadius: '99px',
            border: '1px solid var(--l8)',
          }}
        >
          {' '}
          {(m.rpModeBtns ?? []).map((m, i135) => (
            <Fragment key={i135}>
              {' '}
              <button
                onClick={m?.go}
                aria-label={`${dc.s(m?.label)} mode`}
                style={dc.css(
                  `display:inline-flex;align-items:center;gap:6px;padding:4px 13px;border-radius:99px;border:none;background:${dc.s(m?.bg)};color:${dc.s(m?.fg)};font-weight:${dc.s(m?.fw)};font-size:10.5px;cursor:pointer`,
                )}
              >
                <i className={`ph ${dc.s(m?.icon)}`} style={{ fontSize: '12px' }}></i>
                {dc.t(m?.label)}
              </button>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
        {m.rpIsReplay ? (
          <>
            {' '}
            <div
              style={{
                display: 'flex',
                gap: '2px',
                padding: '3px',
                borderRadius: '99px',
                border: '1px solid var(--l8)',
              }}
            >
              {' '}
              {(m.rpDays ?? []).map((d, i136) => (
                <Fragment key={i136}>
                  {' '}
                  <button
                    onClick={d?.go}
                    title={`Replay ${dc.s(d?.label)}`}
                    aria-label={`Replay ${dc.s(d?.label)}`}
                    style={dc.css(
                      `display:inline-flex;align-items:center;gap:7px;padding:4px 13px;border-radius:99px;border:none;background:${dc.s(d?.bg)};color:${dc.s(d?.fg)};font-weight:${dc.s(d?.fw)};font-size:10.5px;cursor:pointer;white-space:nowrap`,
                    )}
                  >
                    {dc.t(d?.label)}
                    <span
                      style={dc.css(
                        `font-size:9.5px;color:${dc.s(d?.subFg)};opacity:0.75;font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(d?.sub)}
                    </span>
                  </button>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
            <span style={{ fontSize: '11px', color: 'var(--muted2)' }}>{dc.t(m.rpDayLabel)}</span>{' '}
            <div style={{ flex: '1' }}></div>{' '}
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'baseline',
                gap: '8px',
                flex: 'none',
                whiteSpace: 'nowrap',
              }}
            >
              <span
                style={{
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                Day P&L
              </span>
              <span
                style={dc.css(
                  `font-size:12.5px;font-weight:600;color:${dc.s(m.rpDayNetFg)};font-variant-numeric:tabular-nums`,
                )}
              >
                {dc.t(m.rpDayNet)}
              </span>
            </span>{' '}
          </>
        ) : null}{' '}
      </div>{' '}
      {m.rpIsBacktest ? (
        <>
          {' '}
          <div style={{ display: 'flex', gap: '12px', alignItems: 'stretch', flex: '1', minHeight: '0' }}>
            {' '}
            <div
              style={{
                flex: '1',
                minWidth: '0',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                minHeight: '0',
              }}
            >
              {' '}
              {m.btHasRun ? (
                <>
                  {' '}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '12px',
                      flex: '1',
                      minHeight: '0',
                    }}
                  >
                    {' '}
                    <div
                      style={{
                        background: 'var(--surface)',
                        border: '1px solid var(--card-line)',
                        boxShadow: 'var(--shadow-card)',
                        borderRadius: '16px',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        flex: '1 1 0',
                        minHeight: '0',
                      }}
                    >
                      {' '}
                      <div
                        style={{
                          padding: '10px 16px',
                          borderBottom: '1px solid var(--l6)',
                          flex: 'none',
                          minWidth: '0',
                        }}
                      >
                        {' '}
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px', minWidth: '0' }}>
                          {' '}
                          <span
                            style={dc.css(
                              `font-size:19px;font-weight:600;letter-spacing:-0.02em;color:${dc.s(m.btHeadlineFg)};font-variant-numeric:tabular-nums;flex:none`,
                            )}
                          >
                            {dc.t(m.btHeadline)}
                          </span>{' '}
                          <span
                            style={{
                              fontSize: '11px',
                              color: 'var(--muted2)',
                              flex: '1',
                              minWidth: '0',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {dc.t(m.btSub)}
                          </span>{' '}
                        </div>{' '}
                        <div
                          style={dc.css(
                            `font-size:10.5px;color:${dc.s(m.btVerdictFg)};line-height:1.5;margin-top:4px`,
                          )}
                        >
                          {dc.t(m.btVerdict)}
                        </div>{' '}
                      </div>{' '}
                      <div style={{ flex: '1', minHeight: '0', position: 'relative' }}>
                        {' '}
                        <PfTvChart
                          symbol={dc.a(m.btSym)}
                          interval={dc.a(m.btInterval)}
                          theme={dc.a(m.tvTheme)}
                          mode="backtest"
                          markers={dc.a(m.btMarkers)}
                          style={{ position: 'absolute', inset: '0' }}
                        ></PfTvChart>{' '}
                      </div>{' '}
                    </div>{' '}
                    <div
                      style={{
                        background: 'var(--surface)',
                        border: '1px solid var(--card-line)',
                        boxShadow: 'var(--shadow-card)',
                        borderRadius: '16px',
                        overflow: 'hidden',
                        flex: '0 1 auto',
                        maxHeight: '46%',
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '0',
                      }}
                    >
                      {' '}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '11px 16px',
                          flex: 'none',
                        }}
                      >
                        {' '}
                        <span style={{ fontSize: '12.5px', fontWeight: '500' }}>Results</span>{' '}
                        <span style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>{dc.t(m.btSub)}</span>{' '}
                        <div style={{ flex: '1' }}></div>{' '}
                        <button
                          className="scp-4f3e86a"
                          onClick={m.btResultsToggle}
                          title={dc.a(m.btResultsLabel)}
                          aria-label={dc.a(m.btResultsLabel)}
                          aria-expanded={dc.b(m.btResultsOpen)}
                          style={{
                            width: '26px',
                            height: '26px',
                            borderRadius: '9px',
                            border: '1px solid var(--l8)',
                            background: 'transparent',
                            color: 'var(--faint)',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <i className={`ph ${dc.s(m.btResultsIcon)}`} style={{ fontSize: '13px' }}></i>
                        </button>{' '}
                      </div>{' '}
                      {m.btResultsOpen ? (
                        <>
                          {' '}
                          <div
                            style={{ borderTop: '1px solid var(--l6)', overflowY: 'auto', minHeight: '0' }}
                          >
                            {' '}
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,minmax(0,1fr))' }}>
                              {' '}
                              {(m.btStats ?? []).map((s, i137) => (
                                <Fragment key={i137}>
                                  {' '}
                                  <div
                                    style={dc.css(
                                      `padding:12px 16px;border-right:${dc.s(s?.br)};border-bottom:${dc.s(s?.bb)}`,
                                    )}
                                  >
                                    <div
                                      style={{
                                        fontSize: '9px',
                                        letterSpacing: '0.11em',
                                        textTransform: 'uppercase',
                                        color: 'var(--muted2)',
                                        fontWeight: '600',
                                      }}
                                    >
                                      {dc.t(s?.k)}
                                    </div>
                                    <div
                                      style={dc.css(
                                        `font-size:15px;font-weight:600;letter-spacing:-0.02em;margin-top:4px;color:${dc.s(s?.c)};font-variant-numeric:tabular-nums`,
                                      )}
                                    >
                                      {dc.t(s?.v)}
                                    </div>
                                  </div>{' '}
                                </Fragment>
                              ))}{' '}
                            </div>{' '}
                            <div style={{ padding: '13px 16px', borderTop: '1px solid var(--l6)' }}>
                              {' '}
                              <div
                                style={{
                                  fontSize: '9px',
                                  letterSpacing: '0.11em',
                                  textTransform: 'uppercase',
                                  color: 'var(--muted2)',
                                  fontWeight: '600',
                                }}
                              >
                                Assumptions
                              </div>{' '}
                              <div
                                style={{
                                  display: 'grid',
                                  gridTemplateColumns: 'repeat(auto-fit,minmax(210px,1fr))',
                                  gap: '6px 18px',
                                  marginTop: '9px',
                                }}
                              >
                                {' '}
                                {(m.btAssumptions ?? []).map((a, i138) => (
                                  <Fragment key={i138}>
                                    {' '}
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        gap: '12px',
                                        fontSize: '11.5px',
                                        padding: '3px 0',
                                      }}
                                    >
                                      <span style={{ color: 'var(--muted2)' }}>{dc.t(a?.k)}</span>
                                      <span
                                        style={{ color: 'var(--text2)', fontVariantNumeric: 'tabular-nums' }}
                                      >
                                        {dc.t(a?.v)}
                                      </span>
                                    </div>{' '}
                                  </Fragment>
                                ))}{' '}
                              </div>{' '}
                              <div
                                style={{
                                  fontSize: '10.5px',
                                  color: 'var(--faint)',
                                  lineHeight: '1.55',
                                  marginTop: '9px',
                                }}
                              >
                                Modelled from your recorded win rate and average win/loss for this book, not
                                from tick data — a sizing sanity check, not a promise.
                              </div>{' '}
                            </div>{' '}
                          </div>{' '}
                        </>
                      ) : null}{' '}
                    </div>{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
              {m.btBusy ? (
                <>
                  {' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      flex: '1',
                      minHeight: '0',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '12px',
                    }}
                  >
                    {' '}
                    <div
                      style={{ width: '70%', height: '120px', borderRadius: '11px', background: 'var(--l5)' }}
                    ></div>{' '}
                    <div style={{ fontSize: '11px', color: 'var(--muted2)' }}>
                      Simulating sessions against your playbook stats…
                    </div>{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
              {m.btNoRun ? (
                <>
                  {' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      flex: '1',
                      minHeight: '0',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      padding: '24px',
                    }}
                  >
                    {' '}
                    <i className="ph ph-flask" style={{ fontSize: '28px', color: 'var(--ghost)' }}></i>{' '}
                    <div style={{ fontSize: '12.5px', color: 'var(--text-mid)', marginTop: '10px' }}>
                      No backtest yet
                    </div>{' '}
                    <div
                      style={{ fontSize: '11px', color: 'var(--faint)', marginTop: '4px', maxWidth: '380px' }}
                    >
                      Pick a book, a risk level and an entry cap on the right, then run it — the model uses
                      your own recorded win rate and average win/loss for that strategy.
                    </div>{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
            </div>{' '}
            <aside
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                width: '300px',
                flex: '0 1 300px',
                minWidth: '220px',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                minHeight: '0',
              }}
            >
              {' '}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '11px 14px',
                  borderBottom: '1px solid var(--l6)',
                  flex: 'none',
                }}
              >
                {' '}
                <span style={{ fontSize: '12.5px', fontWeight: '500', flex: '1' }}>Backtest Setup</span>{' '}
                <i className="ph ph-flask" style={{ fontSize: '14px', color: 'var(--faint)' }}></i>{' '}
              </div>{' '}
              <div style={{ flex: '1', minHeight: '0', overflowY: 'auto' }}>
                {' '}
                <div style={{ padding: '13px 14px', borderBottom: '1px solid var(--l6)' }}>
                  {' '}
                  <div
                    style={{
                      fontSize: '9px',
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                      color: 'var(--muted2)',
                      fontWeight: '600',
                    }}
                  >
                    Strategy
                  </div>{' '}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '8px' }}>
                    {' '}
                    {(m.btStratBtns ?? []).map((b, i139) => (
                      <Fragment key={i139}>
                        {' '}
                        <button
                          onClick={b?.go}
                          aria-label={`Backtest ${dc.s(b?.label)}`}
                          style={dc.css(
                            `font-size:10.5px;padding:5px 11px;border-radius:99px;border:1px solid ${dc.s(b?.bd)};background:${dc.s(b?.bg)};color:${dc.s(b?.fg)};cursor:pointer`,
                          )}
                        >
                          {dc.t(b?.label)}
                        </button>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: '10px',
                      fontSize: '11.5px',
                      marginTop: '11px',
                    }}
                  >
                    <span style={{ color: 'var(--muted2)' }}>Session window</span>
                    <span style={{ color: 'var(--text2)', fontVariantNumeric: 'tabular-nums' }}>
                      {dc.t(m.btWindow)}
                    </span>
                  </div>{' '}
                </div>{' '}
                <div style={{ padding: '13px 14px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
                  {' '}
                  <div>
                    {' '}
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                      <span
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        Risk per trade
                      </span>
                      <div style={{ flex: '1' }}></div>
                      <span
                        style={{ fontSize: '12px', fontWeight: '600', fontVariantNumeric: 'tabular-nums' }}
                      >
                        {dc.t(m.btRiskLabel)}
                      </span>
                    </div>{' '}
                    <input
                      type="range"
                      min="0.1"
                      max="2"
                      step="0.05"
                      value={dc.v(m.btRisk)}
                      onChange={m.setBtRisk}
                      aria-label="Risk per trade"
                      style={{ width: '100%', marginTop: '8px' }}
                    />{' '}
                  </div>{' '}
                  <div>
                    {' '}
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                      <span
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        Period
                      </span>
                      <div style={{ flex: '1' }}></div>
                      <span
                        style={{ fontSize: '12px', fontWeight: '600', fontVariantNumeric: 'tabular-nums' }}
                      >
                        {dc.t(m.btMonthsLabel)}
                      </span>
                    </div>{' '}
                    <input
                      type="range"
                      min="1"
                      max="24"
                      step="1"
                      value={dc.v(m.btMonths)}
                      onChange={m.setBtMonths}
                      aria-label="Backtest period in months"
                      style={{ width: '100%', marginTop: '8px' }}
                    />{' '}
                  </div>{' '}
                  <div>
                    {' '}
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                      <span
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        Entry cap
                      </span>
                      <div style={{ flex: '1' }}></div>
                      <span
                        style={{ fontSize: '12px', fontWeight: '600', fontVariantNumeric: 'tabular-nums' }}
                      >
                        {dc.t(m.btCapLabel)}
                      </span>
                    </div>{' '}
                    <input
                      type="range"
                      min="1"
                      max="5"
                      step="1"
                      value={dc.v(m.btCap)}
                      onChange={m.setBtCap}
                      aria-label="Entries per session"
                      style={{ width: '100%', marginTop: '8px' }}
                    />{' '}
                  </div>{' '}
                  <button
                    className="scp-84b4671"
                    onClick={m.btGo}
                    aria-label={dc.a(m.btRunLabel)}
                    style={{
                      width: '100%',
                      padding: '11px',
                      borderRadius: '11px',
                      border: '1px solid color-mix(in srgb, var(--sky-fill) 50%, transparent)',
                      background: 'color-mix(in srgb, var(--sky-fill) 10%, transparent)',
                      color: 'var(--sky)',
                      fontSize: '12.5px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    {dc.t(m.btRunLabel)}
                  </button>{' '}
                </div>{' '}
              </div>{' '}
            </aside>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.rpIsReplay ? (
        <>
          {' '}
          <div style={{ display: 'flex', gap: '12px', alignItems: 'stretch', flex: '1', minHeight: '0' }}>
            {' '}
            <div
              style={{
                flex: '1',
                minWidth: '0',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                minHeight: '0',
              }}
            >
              {' '}
              {m.rpHasTrades ? (
                <>
                  {' '}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '12px',
                      flex: '3 1 0',
                      minHeight: '0',
                    }}
                  >
                    {' '}
                    <div
                      style={{
                        background: 'var(--surface)',
                        border: '1px solid var(--card-line)',
                        boxShadow: 'var(--shadow-card)',
                        borderRadius: '16px',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        flex: '1 1 0',
                        minHeight: '0',
                      }}
                    >
                      {' '}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '10px 16px',
                          borderBottom: '1px solid var(--l6)',
                          flex: 'none',
                          minWidth: '0',
                        }}
                      >
                        {' '}
                        <span style={{ fontSize: '12.5px', fontWeight: '600', flex: 'none' }}>
                          {dc.t(m.rpSym)}
                        </span>{' '}
                        <span
                          style={dc.css(
                            `font-size:9.5px;font-weight:600;letter-spacing:0.06em;padding:2px 8px;border-radius:99px;color:${dc.s(m.rpSideFg)};border:1px solid var(--l10);flex:none`,
                          )}
                        >
                          {dc.t(m.rpSide)}
                        </span>{' '}
                        <span
                          style={{
                            fontSize: '11px',
                            color: 'var(--muted2)',
                            flex: '1',
                            minWidth: '0',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {dc.t(m.rpStrat)}
                        </span>{' '}
                        <span
                          style={{
                            fontSize: '9.5px',
                            color: 'var(--faint)',
                            whiteSpace: 'nowrap',
                            flex: 'none',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '34ch',
                          }}
                        >
                          {dc.t(m.rpMarkerNote)}
                        </span>{' '}
                        <span
                          style={dc.css(
                            `font-size:10.5px;color:${dc.s(m.rpOutcomeFg)};white-space:nowrap;flex:none`,
                          )}
                        >
                          {dc.t(m.rpOutcome)}
                        </span>{' '}
                      </div>{' '}
                      <div style={{ flex: '1', minHeight: '0', position: 'relative' }}>
                        {' '}
                        <PfTvChart
                          symbol={dc.a(m.rpSym)}
                          interval={dc.a(m.rpInterval)}
                          theme={dc.a(m.tvTheme)}
                          mode="replay"
                          markers={dc.a(m.rpMarkers)}
                          style={{ position: 'absolute', inset: '0' }}
                        ></PfTvChart>{' '}
                      </div>{' '}
                    </div>{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
              {m.rpNoTrades ? (
                <>
                  {' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '44px 24px',
                      textAlign: 'center',
                    }}
                  >
                    {' '}
                    <i
                      className="ph ph-film-slate"
                      style={{ fontSize: '28px', color: 'var(--ghost)' }}
                    ></i>{' '}
                    <div style={{ fontSize: '12.5px', color: 'var(--text-mid)', marginTop: '10px' }}>
                      {'Nothing to replay on '}
                      {dc.t(m.rpDayLabel)}
                    </div>{' '}
                    <div style={{ fontSize: '11px', color: 'var(--faint)', marginTop: '4px' }}>
                      No trades were taken, so there is no price series or playback for this session.
                    </div>{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  flex: '0 1 auto',
                  maxHeight: '40%',
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: '0',
                }}
              >
                {' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '11px 16px',
                    flex: 'none',
                  }}
                >
                  {' '}
                  <span style={{ fontSize: '12.5px', fontWeight: '500' }}>
                    {'Trades on '}
                    {dc.t(m.rpDayLabel)}
                  </span>{' '}
                  <span
                    style={{
                      fontSize: '9.5px',
                      padding: '2px 9px',
                      borderRadius: '99px',
                      border: '1px solid var(--l8)',
                      color: 'var(--muted)',
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {dc.t(m.rpTradesSummary)}
                  </span>{' '}
                  <span style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>
                    {'Loaded: '}
                    {dc.t(m.rpLoadedLabel)}
                  </span>{' '}
                  <div style={{ flex: '1' }}></div>{' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={m.rpTradesToggle}
                    title={dc.a(m.rpTradesToggleLabel)}
                    aria-label={dc.a(m.rpTradesToggleLabel)}
                    aria-expanded={dc.b(m.rpTradesOpen)}
                    style={{
                      width: '26px',
                      height: '26px',
                      borderRadius: '9px',
                      border: '1px solid var(--l8)',
                      background: 'transparent',
                      color: 'var(--faint)',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <i className={`ph ${dc.s(m.rpTradesIcon)}`} style={{ fontSize: '13px' }}></i>
                  </button>{' '}
                </div>{' '}
                {m.rpTradesOpen ? (
                  <>
                    {' '}
                    <div style={{ borderTop: '1px solid var(--l6)', overflowY: 'auto', minHeight: '0' }}>
                      {' '}
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns:
                            'minmax(34px,0.55fr) minmax(56px,0.95fr) minmax(44px,0.6fr) minmax(46px,0.65fr)',
                          gap: '8px',
                          alignItems: 'center',
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                          padding: '9px 16px',
                          borderBottom: '1px solid var(--l8)',
                        }}
                      >
                        <span>Time</span>
                        <span>Symbol</span>
                        <span>Side</span>
                        <span style={{ textAlign: 'right' }}>Result</span>
                      </div>{' '}
                      {(m.rpTrades ?? []).map((t, i140) => (
                        <Fragment key={i140}>
                          {' '}
                          <button
                            className="scp-4f3e86a"
                            onClick={t?.go}
                            aria-label={`Replay ${dc.s(t?.sym)} at ${dc.s(t?.time)}`}
                            aria-pressed={dc.b(t?.sel)}
                            style={dc.css(
                              `display:block;width:100%;text-align:left;padding:9px 16px;border:none;border-bottom:1px solid var(--l8);background:${dc.s(t?.rowBg)};cursor:pointer`,
                            )}
                          >
                            {' '}
                            <div
                              style={{
                                display: 'grid',
                                gridTemplateColumns:
                                  'minmax(34px,0.55fr) minmax(56px,0.95fr) minmax(44px,0.6fr) minmax(46px,0.65fr)',
                                gap: '8px',
                                alignItems: 'center',
                                fontSize: '11.5px',
                              }}
                            >
                              {' '}
                              <span style={{ color: 'var(--muted)', fontVariantNumeric: 'tabular-nums' }}>
                                {dc.t(t?.time)}
                              </span>{' '}
                              <span style={dc.css(`font-weight:500;color:${dc.s(t?.nameFg)}`)}>
                                {dc.t(t?.sym)}
                              </span>{' '}
                              <span>
                                <span
                                  style={dc.css(
                                    `font-size:9px;font-weight:600;letter-spacing:0.06em;padding:2px 8px;border-radius:99px;background:${dc.s(t?.sideBg)};color:${dc.s(t?.sideFg)}`,
                                  )}
                                >
                                  {dc.t(t?.side)}
                                </span>
                              </span>{' '}
                              <span
                                style={dc.css(
                                  `text-align:right;font-weight:600;color:${dc.s(t?.pnlFg)};font-variant-numeric:tabular-nums`,
                                )}
                              >
                                {dc.t(t?.r)}
                              </span>{' '}
                            </div>{' '}
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                marginTop: '6px',
                                minWidth: '0',
                              }}
                            >
                              {' '}
                              <span
                                style={{
                                  fontSize: '11px',
                                  color: 'var(--muted2)',
                                  flex: '1',
                                  minWidth: '0',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {dc.t(t?.strat)}
                              </span>{' '}
                              <span
                                style={dc.css(
                                  `font-size:10.5px;color:${dc.s(t?.pnlFg)};font-variant-numeric:tabular-nums;flex:none`,
                                )}
                              >
                                {dc.t(t?.pnl)}
                              </span>{' '}
                              <span style={{ fontSize: '10px', color: 'var(--muted2)', flex: 'none' }}>
                                {dc.t(t?.grade)}
                              </span>{' '}
                              <span
                                style={dc.css(
                                  `display:inline-flex;align-items:center;gap:5px;font-size:10px;padding:3px 10px;border-radius:99px;border:1px solid ${dc.s(t?.markBd)};background:${dc.s(t?.markBg)};color:${dc.s(t?.markFg)};flex:none`,
                                )}
                              >
                                <i className={`ph ${dc.s(t?.markIcon)}`} style={{ fontSize: '11px' }}></i>
                                {dc.t(t?.markLabel)}
                              </span>{' '}
                            </div>{' '}
                          </button>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                  </>
                ) : null}{' '}
                {m.rpNoTrades ? (
                  <>
                    {' '}
                    <div style={{ padding: '30px 20px', textAlign: 'center' }}>
                      <i className="ph ph-moon-stars" style={{ fontSize: '24px', color: 'var(--ghost)' }}></i>
                      <div style={{ fontSize: '12px', color: 'var(--text-mid)', marginTop: '8px' }}>
                        No trades to replay on this day
                      </div>
                      <div style={{ fontSize: '11px', color: 'var(--faint)', marginTop: '3px' }}>
                        Pick another day above.
                      </div>
                    </div>{' '}
                  </>
                ) : null}{' '}
              </div>{' '}
            </div>{' '}
            <aside
              style={{
                width: '300px',
                flex: '0 1 300px',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                minWidth: '220px',
                minHeight: '0',
                overflowY: 'auto',
              }}
            >
              {' '}
              {m.rpHasTrades ? (
                <>
                  {' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '12px 16px',
                    }}
                  >
                    {' '}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        Playback
                      </span>
                      <div style={{ flex: '1' }}></div>
                      <span
                        style={{
                          fontSize: '11px',
                          color: 'var(--muted)',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(m.rpBarLabel)}
                      </span>
                    </div>{' '}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        marginTop: '11px',
                        flexWrap: 'wrap',
                      }}
                    >
                      {' '}
                      <button
                        className="scp-4f3e86a"
                        onClick={m.rpBack}
                        title="Back 50 bars"
                        aria-label="Back 50 bars"
                        style={{
                          borderRadius: '9px',
                          border: '1px solid var(--l10)',
                          background: 'transparent',
                          color: 'var(--muted)',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '30px',
                          height: '30px',
                        }}
                      >
                        <i className="ph ph-skip-back" style={{ fontSize: '13px' }}></i>
                      </button>{' '}
                      <button
                        className="scp-84b4671"
                        onClick={m.rpPlay}
                        title={dc.a(m.rpPlayLabel)}
                        aria-label={dc.a(m.rpPlayLabel)}
                        aria-pressed={dc.b(m.rpPlaying)}
                        style={{
                          width: '34px',
                          height: '34px',
                          borderRadius: '9px',
                          border: '1px solid color-mix(in srgb, var(--sky-fill) 50%, transparent)',
                          background: 'color-mix(in srgb, var(--sky-fill) 10%, transparent)',
                          color: 'var(--sky)',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <i className={`ph-fill ${dc.s(m.rpIcon)}`} style={{ fontSize: '14px' }}></i>
                      </button>{' '}
                      <button
                        className="scp-4f3e86a"
                        onClick={m.rpFwd}
                        title="Forward 50 bars"
                        aria-label="Forward 50 bars"
                        style={{
                          borderRadius: '9px',
                          border: '1px solid var(--l10)',
                          background: 'transparent',
                          color: 'var(--muted)',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '30px',
                          height: '30px',
                        }}
                      >
                        <i className="ph ph-skip-forward" style={{ fontSize: '13px' }}></i>
                      </button>{' '}
                      <div
                        style={{
                          flex: '1',
                          minWidth: '140px',
                          height: '5px',
                          borderRadius: '99px',
                          background: 'var(--l7)',
                          overflow: 'hidden',
                        }}
                      >
                        <div
                          style={dc.css(
                            `width:100%;height:100%;background:var(--sky-fill);transform:scaleX(${dc.s(m.rpProgScale)});transform-origin:left center;transition:transform 90ms linear`,
                          )}
                        ></div>
                      </div>{' '}
                      <button
                        className="scp-4f3e86a"
                        onClick={m.rpCycleSpeed}
                        title="Playback speed"
                        aria-label="Change playback speed"
                        style={{
                          fontSize: '10.5px',
                          padding: '5px 12px',
                          borderRadius: '99px',
                          border: '1px solid var(--l8)',
                          background: 'transparent',
                          color: 'var(--text-mid)',
                          cursor: 'pointer',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(m.rpSpeedLabel)}
                      </button>{' '}
                    </div>{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
              {m.rpHasTrades ? (
                <>
                  {' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '14px 16px',
                    }}
                  >
                    {' '}
                    <div
                      style={{
                        fontSize: '9px',
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      Trade
                    </div>{' '}
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '9px 12px',
                        marginTop: '10px',
                      }}
                    >
                      {' '}
                      {(m.rpMeta ?? []).map((m, i141) => (
                        <Fragment key={i141}>
                          {' '}
                          <div>
                            <div
                              style={{
                                fontSize: '9px',
                                letterSpacing: '0.11em',
                                textTransform: 'uppercase',
                                color: 'var(--muted2)',
                                fontWeight: '600',
                              }}
                            >
                              {dc.t(m?.k)}
                            </div>
                            <div
                              style={dc.css(
                                `font-size:12px;font-weight:500;margin-top:2px;font-variant-numeric:tabular-nums;color:${dc.s(m?.c)}`,
                              )}
                            >
                              {dc.t(m?.v)}
                            </div>
                          </div>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '14px 16px',
                }}
              >
                {' '}
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Session
                </div>{' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '10px' }}>
                  {' '}
                  {(m.rpSess ?? []).map((s, i142) => (
                    <Fragment key={i142}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          gap: '10px',
                          fontSize: '11.5px',
                        }}
                      >
                        <span style={{ color: 'var(--muted2)' }}>{dc.t(s?.k)}</span>
                        <span
                          style={{
                            fontVariantNumeric: 'tabular-nums',
                            color: 'var(--text2)',
                            textAlign: 'right',
                          }}
                        >
                          {dc.t(s?.v)}
                        </span>
                      </div>
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </div>{' '}
              {m.rpHasTrades ? (
                <>
                  {' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '14px 16px',
                    }}
                  >
                    {' '}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '7px',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: 'var(--vio)',
                      }}
                    >
                      <i className="ph-fill ph-sparkle" style={{ fontSize: '14px' }}></i>AI trade analysis
                    </div>{' '}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '12px' }}>
                      {' '}
                      {(m.rpAi ?? []).map((a, i143) => (
                        <Fragment key={i143}>
                          {' '}
                          <div
                            style={{
                              border: '1px solid var(--l8)',
                              borderRadius: '11px',
                              padding: '11px 12px',
                            }}
                          >
                            {' '}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <span style={{ fontSize: '11.5px', color: 'var(--text-mid)', flex: '1' }}>
                                {dc.t(a?.label)}
                              </span>
                              <span
                                style={dc.css(
                                  `font-size:15px;font-weight:600;color:${dc.s(a?.col)};font-variant-numeric:tabular-nums`,
                                )}
                              >
                                {dc.t(a?.score)}
                                <span style={{ fontSize: '10px', color: 'var(--muted2)' }}>/10</span>
                              </span>
                            </div>{' '}
                            <div
                              style={dc.css(
                                `font-size:10px;font-weight:600;color:${dc.s(a?.col)};margin-top:2px`,
                              )}
                            >
                              {dc.t(a?.tag)}
                            </div>{' '}
                            <div
                              style={{
                                fontSize: '10.5px',
                                color: 'var(--muted)',
                                lineHeight: '1.55',
                                marginTop: '5px',
                              }}
                            >
                              {dc.t(a?.narr)}
                            </div>{' '}
                          </div>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '14px 16px',
                  flex: '1',
                  minHeight: '96px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {' '}
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Journal note
                </div>{' '}
                <div
                  style={{
                    fontSize: '11.5px',
                    color: 'var(--text-mid)',
                    lineHeight: '1.6',
                    marginTop: '8px',
                    flex: '1',
                    overflowY: 'auto',
                    minHeight: '0',
                  }}
                >
                  {dc.t(m.rpNote)}
                </div>{' '}
              </div>{' '}
            </aside>{' '}
          </div>{' '}
        </>
      ) : null}
    </div>
  );
}
